import React from 'react'
import cls from './Navigation.module.scss'
import { scrollIntoView } from '@/shared/lib/utils/scrollIntoView'
import { useTranslation } from 'react-i18next'

export const Navigation = () => {
    const { t } = useTranslation()
    return (
        <div className={cls.Navigation}>
            <a
                href="https://stellar-bets.com/"
            >
                {t('navigation.aboutus')}
            </a>

            <p onClick={() => scrollIntoView('benefits')}>{t('navigation.benefits')}</p>
            <p onClick={() => scrollIntoView('instructions')}>{t('navigation.howwework')}</p>
            <p
                onClick={() => {
                    scrollIntoView('distributor')
                }}
            >
                {t('navigation.become')}
            </p>
        </div>
    )
}
